import React from 'react'
import styled from 'styled-components'

interface Props {
    title: string
    targetProgress?: number
    currProgress?: number
    status: string
    color: string,
    percent:number
}

const loadingConfig = {
    color1: '#eaebee',
    color2: '#37A3EF',
    speed: '6s'
}

export default function LoadingBar({ title, targetProgress = -1, currProgress, status, color = '#37A3EF',percent }: Props) {
    const resolveProgress = () => {
        return (100 * currProgress) / targetProgress
    }
    
    const bar =
        targetProgress !== -1 ? (
            <div className="bar">
                <div className="lines">
                    <div
                        style={{
                            backgroundColor: color,
                            flex: '1 1',
                            maxWidth: `${resolveProgress()}%`,
                            minWidth: `${resolveProgress()}%`
                        }}
                    ></div>
                    <div style={{ backgroundColor: '#eaebee', flex: '1 1' }}></div>
                </div>
            </div>
        ) : (
            <ProcessLoading loadingConfig={loadingConfig} pct={percent} >                
            </ProcessLoading>
        )

    return (
        <Container>
            <label>{title || ''}</label>
            {bar}
            <span>
                <i className="fal fa-info-circle"></i>
                {status || ''}
            </span>
        </Container>
    )
}
interface PropsProgress {
    loadingConfig: { color1: string; color2: string; speed: string }
    pct: number
}

const ProcessLoading = styled.div<PropsProgress>`
    
    width: 100%;
    position: relative;
    height: 12px;

    ::before,::after{
        position: absolute;
        content: '';
        min-height: 8px;
        border-radius: 10px;
        padding: 0.5rem 0;   
    }

    ::after {       
        width: ${({ pct }) => `${Math.max(2, Math.min(100, pct))}%`} ;        
        background-color: ${props => props.loadingConfig.color2};        
        will-change: background-position;
    }
    ::before{      
        width:100%;        
        background-color: #eaebee;                
    }
`

const Container = styled.div`
    font-family: Source Sans Pro;
    color: #606a80;

    label {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
    }

    span {
        font-style: italic;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;

        i {
            padding-right: 0.4rem;
        }
    }
    .bar {
        padding: 0.5rem 0;

        .lines {
            display: flex;
            flex: 1;
            border-radius: 50px;
            height: 9px;
            overflow: hidden;
        }
    }
`
